import React, { FC } from 'react';
import { Typography } from '@/components/atoms/Typography';
import { Tag } from './AutoCompleteTagInput';

type Props = {
  tags?: { id: string; name: string }[];
  onClick: (tag: Tag) => void;
};

export const Tags: FC<Props> = ({ tags, onClick }) => {
  return (
    <ul className="flex flex-row flex-wrap">
      {tags
        ? tags.map((tag) => (
            <li
              key={tag.id}
              className="list-none [&:not(:first-child)]:mx-2 my-0 hover:cursor-pointer white-space: nowrap"
              onClick={() => onClick({ id: tag.id, text: tag.name })}
            >
              <Typography variant="paragraph" color="gray">
                {tag.name}
              </Typography>
            </li>
          ))
        : null}
    </ul>
  );
};
